<div id="simple-page">
  <main>
    <div class="wrapper">
      <hyperkit-typography variant="h1" align="center" color="primary">
        We've moved!</hyperkit-typography
      >
      @if (hasVerityAccess) {
        <hyperkit-typography
          variant="body"
          size="md"
          align="center"
          color="secondary"
        >
          Hunter is now part of Hunt Mode in Verity. Your hunts, hunt packages,
          and threat-hunting content are all still available
          there.</hyperkit-typography
        >
        <div class="buttons">
          <hyperkit-button
            color="primary"
            text="Go to Verity"
            (click)="goToVerity()"
          ></hyperkit-button>
        </div>
        <hyperkit-link
          (click)="contactSupport()"
          variant="emphasized"
          size="sm"
          color="primary"
          text="Having trouble accessing Verity? Contact support."
        ></hyperkit-link>
      } @else {
        <hyperkit-typography
          variant="body"
          size="md"
          align="center"
          color="secondary"
        >
          Hunter is now part of Hunt Mode in Verity, but we couldn't find a
          Verity account for you yet. Contact support to get set
          up.</hyperkit-typography
        >
        <div class="buttons">
          <hyperkit-button
            color="primary"
            text="Contact support"
            (click)="contactSupport()"
          ></hyperkit-button>
        </div>
      }
    </div>
  </main>
</div>
